import { RequestFormHeader } from '@Types/index';

export const getDefaultRequestState = (): RequestFormHeader => {
  return {
    reqStatusId: 0,
    createdDate: '',
    requestId: 0,
    requisitionNo: '',
  };
};
